import React, { useContext, createContext } from 'react';
import {
  PostingMethodAction,
  PostingMethodsStore,
  usePostingMethodReducer,
} from '../store/postingMethodsStore';

export const PostingMethodContextStore = createContext({} as PostingMethodsStore);
export const PostingMethodDispatch = createContext({} as React.Dispatch<PostingMethodAction>);

export const usePostingMethodStore = () => {
  const store = useContext(PostingMethodContextStore);

  if (!store) {
    throw new Error('There is no store provider');
  }

  return store;
};

export const usePostingMethodDispatch = () => {
  const dispatch = useContext(PostingMethodDispatch);

  if (!dispatch) {
    throw new Error('There is no dispatch provider');
  }

  return dispatch;
};

interface PostingMethodContextProviderProps {
  children: React.ReactNode;
}

export const PostingMethodContextProvider = ({ children }: PostingMethodContextProviderProps) => {
  const { state: postingReducerState, dispatch } = usePostingMethodReducer();

  return (
    <PostingMethodContextStore.Provider value={postingReducerState}>
      <PostingMethodDispatch.Provider value={dispatch}>{children}</PostingMethodDispatch.Provider>
    </PostingMethodContextStore.Provider>
  );
};
